import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, firstValueFrom, fromEvent, Subscription, take } from 'rxjs';
import { IonModal, ModalController } from '@ionic/angular';
import { NyomtatasNezet, nyomtatHtml, orarendNyomtatasHtml } from './orarend-nyomtatas';
import { helyettesitoLista as helyettesitoListaKeszit } from './helyettesito-jeloltek';
import { TanarComponent } from '../components/tanar/tanar.component';
import { TanteremComponent } from '../components/tanterem/tanterem.component';
import { TantargyComponent } from '../components/tantargy/tantargy.component';
import { OsztalyComponent } from '../components/osztaly/osztaly.component';
import { Calendar, CalendarOptions, EventClickArg } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid'
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { FullCalendarComponent } from '@fullcalendar/angular';
import moment from 'moment';
import 'moment/locale/hu'
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { esemenyCimHtml } from '../naptar/tanevrendje-tipusok';

@Component({
  selector: 'app-orarendv2',
  templateUrl: './orarendv2.component.html',
  styleUrls: ['./orarendv2.component.scss'],
})
export class Orarendv2Component implements OnInit, AfterViewInit {
  correctCards: number = 0;
  success: boolean = false;
  cards = []; // Cards to drag
  slots = []; // Slots to drop into
  isSlotFilled: boolean[][] = []; // Track which slots are filled
  cardInSlot = []; // Store the card in the slot
  latottHet = [];
  calendarready = false;
  calapi?: Calendar
  orarendmode = "osztaly"
  kivosztaly = "377f3a34-2a8c-11f0-9a26-96530c0175a2"
  kivtanar = null
  kivterem = null
  kivtantargy = null
  selectedUser
  tankezd
  tanvege
  tanfelev
  blokk = []
  allomanyKi = []
  allomanyBe = []
  torlesmod = "C"

  @ViewChild(FullCalendarComponent, { static: false }) cal!: FullCalendarComponent;
  @ViewChild("orarendmodal") orarendmodal: IonModal;
  @ViewChild("helyettesitesmodal") helyettesitesmodal: IonModal;
  @ViewChild("nyomtatasmodal") nyomtatasmodal: IonModal;

  /** A megjelenített hét órái, ahogy a kiszolgáló adta – ebből készül a nyomtatott lap. */
  hetOrak: any[] = [];

  /*  ═══ HELYETTESÍTŐ KERESÉSE ═══
   *  A helyettesítő-választó eddig az egész állományt mutatta (a foglaltakat csak
   *  kiszürkítve), így egy 40 fős tantestületben mindenkit végig kellett nézni. Most a
   *  kiszolgáló tanáronként megmondja, ki szabad, ki van aznap amúgy is bent (lyukasóra),
   *  ki szaktanár vagy tanítja az osztályt, és kinek hány helyettesítése van a héten –
   *  a lista ebből csoportosít és rangsorol. */
  helyettesitoJeloltek: any = null;
  helyettesitoLista: any[] = [];
  helyettesitoMindenki = false;
  private helyettesitettOra: any = null;
  /*  Az elmaradt óra önálló állapot (orarendv2.elmaradt, 2026-10-15) – a helyettesítés-ablak
   *  fejlécében külön gombbal jelölhető / vonható vissza (backend/ora-naplo.js › elmaradt). */
  helyettesitettOraElmaradt = false;
  helyettesitettOraElmaradtOk: string | null = null;
  nyomtatas = { cim: '', datumMutat: true, helyettesitesekkel: false };
  /*set cal(cmp: FullCalendarComponent | undefined) {
  if (!cmp) return;                    // not yet in view / got destroyed
  this.calapi = cmp.getApi();            // <-- NOW it's safe
  this.onCalendarReady();
}*/

  headerTitle = '';
  view: string = 'workWeek';
  calendarOptions: CalendarOptions = {
    plugins: [timeGridPlugin, interactionPlugin, bootstrap5Plugin],
    initialView: 'workWeek',
    locale: 'hu',
    height: 'auto',
    themeSystem: 'standard',
    slotEventOverlap: false,
    eventOverlap: false,
    eventClick: (arg) => this.onEventClick(arg),
    firstDay: 1,
    //initialDate: (moment(new Date()).isBetween(moment(new Date().getFullYear() + "-08-01"), moment(new Date().getFullYear() + "-08-31"), 'day', '[]')) ? this.tankezd : "",
    datesSet: (arg: any) => {
      if (arg?.view?.currentStart && arg?.view?.currentEnd) {
        this.headerTitle = this.buildTitle(arg.view.currentStart, arg.view.currentEnd);
        if (!this.csengetes?.length) return;
      }
    },



    /*headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'agendaDay,workWeek,workWeekSat,agendaWeek fullScreen'
    },*/
    headerToolbar: false,

    // Button texts
    buttonText: {
      today: 'ma',
      day: 'Nap',
      week: 'Hét',
      workWeek: 'Munkahét',
      workWeekSat: 'Munkahét szombattal'
    },

    // Custom buttons (optional)
    customButtons: {
      fullScreen: {
        text: '⤢',
        click() {
          const el = document.documentElement;
          if (!document.fullscreenElement) el.requestFullscreen?.();
          else document.exitFullscreen?.();
        }
      }
    },

    // Views
    views: {
      // Mon–Fri
      workWeek: {
        type: 'timeGridWeek',
        weekends: false,
        dayHeaderContent: arg => {
          // két sor: nap neve + "június 2."
          const d = arg.date;
          return {
            html: `${d.toLocaleString('hu-HU', { weekday: 'long' })}<br>${d.toLocaleString('hu-HU', { month: 'long' })} ${d.getDate()}.`
          };
        }
      },
      // Mon–Sat (no Sunday)
      workWeekSat: {
        type: 'timeGridWeek',
        hiddenDays: [0], // hide Sunday only
        dayHeaderContent: arg => {
          const d = arg.date;
          return {
            html: `${d.toLocaleString('hu-HU', { weekday: 'long' })}<br>${d.toLocaleString('hu-HU', { month: 'long' })} ${d.getDate()}.`
          };
        }
      },
      // Legacy names in your screenshot:
      agendaDay: { type: 'timeGridDay', buttonText: 'Nap' },
      agendaWeek: { type: 'timeGridWeek', buttonText: 'Hét' }
    },

    // Title like "2025. június 2 — 8."
    //titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },


    allDaySlot: true,
    allDayText: 'Események',

    // Turn hours into "0. Óra", "1. Óra", …
    slotMinTime: '00:00:00',
    slotMaxTime: '10:00:00',          // 0..9. Óra (adjust as needed)
    slotDuration: '00:15:00',
    slotLabelInterval: '01:00:00',
    //slotLabelFormat: 'H.[. Óra]',
    slotLabelContent: arg => {
      // compute “period index” from the minTime
      const hour = arg.date.getHours(); // starts at 0 with slotMinTime 00:00
      return `${hour}. óra`;
    },

    // Event look & feel
    eventBackgroundColor: 'var(--ion-color-primary)',
    eventBorderColor: 'var(--ion-color-primary-shade)',
    eventTextColor: 'var(--ion-color-primary-contrast)',
    displayEventEnd: false,
    eventTimeFormat: { hour: '2-digit', minute: '2-digit', hour12: false }, // you can hide times entirely if you want
    eventContent: arg => {
      // allow line breaks in titles like in your screenshot
      const lines = arg.event.title.split('\n').map(t => `<div>${t}</div>`).join('');
      return { html: lines };
    },

    // Example events
    events: [
      /*{
        title: '<div style="text-align:center;line-height:115px;vertical-align:middle;cursor:pointer"><ion-icon name="add-circle-outline" size="large"></ion-icon></div>',
        start: '1900-01-01T00:00:00', end: '1900-01-01T01:00:00',
        textColor: 'var(--ion-color-primary)', backgroundColor: 'transparent', borderColor: 'var(--ion-color-primary)'
      },*/
      /*{
        title: 'magyar - 3. z.\nHuszkáné Alexandrov Andrea\n(második)',
        start: '1900-01-01T01:00:00', end: '1900-01-01T02:00:00',
        textColor: '#000', backgroundColor: '#fbbf24', borderColor: '#d97706'
      },*/
      // … add the rest
    ]
  };


  allomany = [];
  orarend = [];
  csengetes = [];
  osztaly = [];
  tantargy = [];
  terem = [];
  csoportok = [];
  ttf = [];
  filled = [];
  elhasznalt = [];
  sajatIntezmeny;
  mostdrag

  title = 'context-menu';
  isDisplayContextMenu: boolean;
  rightClickMenuItems: Array<any> = [];
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;
  protected readonly JSON = JSON;
  protected readonly environment = environment;

  @ViewChild('userMenu') userMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;
  sub: Subscription;
  @ViewChild(IonModal) modal: IonModal;
  kivalasztottora
  nezet = 1
  het = 0
  napok = ["Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"]
  hetek = ["A", "B", "C", "D", "E", "F", "G"]
  formo: FormGroup;
  formh: FormGroup;
  oraevent
  orameta
  orarenduzemmod = "orarend"


  /*  HELYETTESÍTÉSEK KÜLSŐ NÉZETE.
   *
   *  A cím ide tartozik, nem a naptárhoz: a helyettesítés az órarend ügye. A lista
   *  bejelentkezés nélkül nyílik, ezért nincs benne titkos kulcs – a beágyazó oldal
   *  (SharePoint, Teams) legfeljebb a bejelentkezett felhasználó e-mail címét tudja
   *  hozzáfűzni, és az is csak a KIEMELÉST vezérli, a láthatóságot nem. */
  kulsoNezetCim(): string {
    const om = this.sajatIntezmeny?.intezmenyId || '';
    if (!om) return '';
    try { return new URL(`/api/helyettesites/embed/${om}`, window.location.origin).toString(); }
    catch (e) { return `/api/helyettesites/embed/${om}`; }
  }

  async kulsoNezetMasol(cim: string) {
    try {
      await navigator.clipboard.writeText(cim);
      this.data.sendToast('A cím a vágólapra került.', 'success');
    } catch (e) {
      this.data.sendToast('A másolás nem sikerült – jelöld ki és másold kézzel.', 'warning');
    }
  }

  constructor(private formBuilder: FormBuilder, private modalCtrl: ModalController, public viewContainerRef: ViewContainerRef, public overlay: Overlay, private http: HttpClient, private ref: ChangeDetectorRef, private data: DataService) {
    this.sajatIntezmeny = (this.data.getFromStorage("sajatIntezmeny"));

    this.init();
  }

  /*  Új órát rögzítünk-e (szemben a meglévő szerkesztésével). A darabszám-mező csak
   *  új óránál látszik: meglévőn nincs értelme „5 darabot" kérni. */
  ujOra = true;

  async ngOnInit() {
    this.formo = this.formBuilder.group({
      selectedUser: new FormControl(this.kivtanar ?? "", [Validators.required]),
      osztaly: new FormControl(this.kivosztaly ?? "", [Validators.required]),
      hetirend: new FormControl("O", [Validators.required]),
      tanterem: new FormControl(this.kivterem ?? "", [Validators.required]),
      tantargy: new FormControl(this.kivtantargy ?? "", [Validators.required]),
      erv_kezd: new FormControl("", [Validators.required]),
      nap: new FormControl("", [Validators.required]),
      napszam: new FormControl("", [Validators.required]),
      ora: new FormControl("", [Validators.required]),
      csengetes: new FormControl(""),
      ido: new FormControl("C", [Validators.required]),
      hossz: new FormControl(1, [Validators.required]),
      /*  TÖMEGES RÖGZÍTÉS: hány egymást követő órahelyre kerüljön ugyanez az óra.
       *  Csak ÚJ óránál van értelme, ezért szerkesztéskor el is rejtjük. */
      darab: new FormControl(1),
      csoport: new FormControl(null),
      /*  KÖTÖTT TÚLÓRA (orarendv2.tulora). Eddig sehol nem lehetett jelölni, pedig a
       *  munkaidő-elszámolás és a túlóra-számláló ebből dolgozik. Az „Időtartam”
       *  hatókörére érvényes, a már naplózott órákra is (a kiszolgáló külön írja rájuk). */
      tulora: new FormControl(false),
    });
    this.formh = this.formBuilder.group({
      selectedUser: new FormControl(this.kivtanar ?? "", [Validators.required]),
      ido: new FormControl("C", [Validators.required]),
      tipus: new FormControl("E", [Validators.required]),
      mod: new FormControl("H", [Validators.required]),
    });
    this.nezet = await this.data.getFromStorage("orarendNezet") ?? "1"

    this.kivosztaly = null
    this.kivtanar = null
    this.kivterem = null
    this.kivtantargy = null


    //this.init();

  }
  async ngAfterViewInit() {
    // you can now safely call getApi()
    //this.calapi = this.cal.getApi()
    //this.init();
    //this.onCalendarReady()+
    // A megjelenített tanév a fejléc tanév-választójából jön (munkatanév): korábbi
    // tanévre visszaváltva a RÉGI órarendet és osztályokat kell látni, nem az újakat.
    const akttev = await this.data.getMunkatanev();
    const aktualis = await this.data.getAktualisTanev();
    const tanevadatok = JSON.parse(await this.data.getFromStorage("tanevadatok")) || [];
    let tanev = tanevadatok.filter(d => d.id == akttev)[0]
      || tanevadatok.filter(d => d.id == aktualis)[0];
    this.tankezd = moment(tanev.tankezd).format("YYYY-MM-DD")
    this.tanfelev = moment(tanev.felev).format("YYYY-MM-DD")


    this.osztaly = await this.data.getOsztaly(moment(tanev.tankezd).format("YYYY"), this.sajatIntezmeny.intezmenyId).toPromise();
    this.terem = await this.data.getTanterem(moment(tanev.tankezd).format("YYYY"), this.sajatIntezmeny.intezmenyId).toPromise();
    this.tantargy = await this.data.getTantargy(moment(tanev.tankezd).format("YYYY"), this.sajatIntezmeny.intezmenyId).toPromise();
    try {
      this.csoportok = await this.http.get<any[]>(`/api/tanuloi-csoport/csoportok/${this.sajatIntezmeny.intezmenyId}`).toPromise() || [];
    } catch (e) { this.csoportok = []; }

    this.tanvege = moment(tanev.tanvege).format("YYYY-MM-DD")

    let umd = await this.data.getFromStorage("userMetadata")
    if (umd.department == "admin" || umd.extra_jogok.indexOf("orarend") !== -1) {
      this.changeOrarendUzemmod("admin")
    } else
      //console.log(this.tankezd)
      this.onCalendarReady()



  }
  kivalaszt(mit, e) {
    //console.log(mit)
    //console.log(e)
    this.kivosztaly = null
    this.kivtanar = null
    this.kivterem = null
    this.kivtantargy = null
    if (mit == "osztaly") { this.kivosztaly = e?.id ?? e }
    if (mit == "tanar") { this.kivtanar = e?.adid ?? e }
    if (mit == "terem") { this.kivterem = e?.id ?? e }
    if (mit == "tantargy") { this.kivtantargy = e?.id ?? e }
    this.onCalendarReady()
  }

  /*  A helyettesítő ablak fejlécében látszik, MELYIK órát írja ki az admin: dátum + nap,
   *  hányadik óra, osztály/csoport, tantárgy (és a tartó tanár, terem). */
  helyettesitettOraFejlec: { idopont: string, cel: string, tantargy: string, tarto: string, terem: string } | null = null

  private helyettesitettOraFejlecKeszit(meta: any, kezdet: Date) {
    const szoveg = (v: any) => (v === null || v === undefined ? '' : String(v).trim())
    const napNevek = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
    const d = moment(meta?.datum || kezdet)
    const ora = Number(meta?.ora ?? moment(kezdet).hours())
    const hossz = Number(meta?.hossz) || 1
    const oraSzoveg = hossz > 1 ? `${ora}–${ora + hossz - 1}. óra` : `${ora}. óra`
    const tartokod = szoveg(meta?.tartokod)
    this.helyettesitettOraFejlec = {
      idopont: `${d.format('YYYY.MM.DD.')} ${napNevek[d.day()]}, ${oraSzoveg}`,
      cel: szoveg(meta?.osztaly) || szoveg(meta?.csoportnev),
      tantargy: szoveg(meta?.tantargy),
      tarto: szoveg(meta?.tarto) + (tartokod ? ` (${tartokod})` : ''),
      terem: szoveg(meta?.terem),
    }
  }

  private async helyettesitoJeloltekBetolt(meta: any, kezdet: Date) {
    this.helyettesitettOra = meta
    this.helyettesitettOraFejlecKeszit(meta, kezdet)
    this.helyettesitoMindenki = false
    this.helyettesitoJeloltek = null
    try {
      const datum = moment(kezdet).format("YYYY-MM-DD")
      const ora = moment(kezdet).format("H")
      this.helyettesitoJeloltek = await firstValueFrom(this.http.get(
        `/api/orarend/helyettesito-jeloltek/${datum}/${ora}/${this.sajatIntezmeny.intezmenyId}`
        + (meta?.id ? `?ora_id=${encodeURIComponent(meta.id)}` : '')))
    } catch (e) {
      // Tartalék: a korábbi, csak foglaltságot ismerő lista (allomanyKi / allomanyBe).
      this.helyettesitoJeloltek = null
    }
    this.helyettesitoListaEpit()
  }

  /*  ELMARADT ÓRA (user, 2026-10-15): a helyettesítő maga az óra tanára, automatikusan, és
   *  nem lehet másra átállítani – elmaradt órát nem tart senki más. A munkaidő-elszámolás az
   *  „E” módot nem számolja helyettesítésnek (munkaido-elszamolas.js), így a tanárnál sem
   *  jelenik meg helyettesítésként. A vezérlő letiltva van, ezért a mentés getRawValue()-t olvas. */
  private elmaradtTanar(): string {
    return String(this.helyettesitoJeloltek?.cel?.tanar ?? this.helyettesitettOra?.tanar ?? '')
  }
  helyettesitesModValt() {
    const vez = this.formh?.get('selectedUser')
    if (!vez) return
    if (this.formh.getRawValue().mod === 'E') {
      vez.setValue(this.elmaradtTanar() || null)
      vez.disable({ emitEvent: false })
    } else if (vez.disabled) {
      vez.enable({ emitEvent: false })
      if (vez.value === this.elmaradtTanar()) vez.setValue(null)
    }
    this.helyettesitoListaEpit()
  }

  helyettesitoListaEpit() {
    if (this.formh?.getRawValue?.().mod === 'E') {
      //  Elmaradtnál csak a tartó tanár áll a listában – a választó az ő nevét mutatja.
      const t = this.elmaradtTanar()
      this.helyettesitoLista = (this.allomany || []).filter((a: any) => String(a.adid) === t)
        .map((a: any) => ({ ...a, csoport: 'Elmaradt – az óra saját tanára' }))
      return
    }
    const osszevonas = this.formh?.value?.mod === 'O'
    if (!this.helyettesitoJeloltek?.tanarok) {
      this.helyettesitoLista = osszevonas ? this.allomanyBe : this.allomanyKi
      return
    }
    this.helyettesitoLista = helyettesitoListaKeszit({
      allomany: this.allomany || [],
      jeloltek: this.helyettesitoJeloltek,
      osszevonas,
      mindenki: this.helyettesitoMindenki,
      kivalasztott: String(this.formh?.value?.selectedUser ?? ''),
      tarto: String(this.helyettesitoJeloltek?.cel?.tanar ?? this.helyettesitettOra?.tanar ?? ''),
    })
  }

  /*  ═══ NYOMTATÁS ═══
   *  Minden nézetben (osztály, tanár, terem, tantárgy) a megjelenített hét kerül a
   *  lapra; a cím a kiválasztott elem neve, a nyomtatás előtt átírható. */
  private nyomtatasNezet(): NyomtatasNezet {
    return ({ '1': 'osztaly', '2': 'tanar', '3': 'terem', '4': 'tantargy' } as any)[String(this.nezet)] || 'osztaly';
  }

  private kivalasztottAzonosito(): string | null {
    return this.kivtanar ?? this.kivosztaly ?? this.kivterem ?? this.kivtantargy ?? null;
  }

  private kivalasztottNev(): string {
    const id = String(this.kivalasztottAzonosito() ?? '');
    const talal = (lista: any[], kulcs: string) => (lista || []).find((x: any) => String(x?.[kulcs]) === id);
    switch (this.nyomtatasNezet()) {
      case 'osztaly': return talal(this.osztaly, 'id')?.osztaly || '';
      case 'tanar': return talal(this.allomany, 'adid')?.full_name || '';
      case 'terem': return talal(this.terem, 'id')?.name || '';
      case 'tantargy': return talal(this.tantargy, 'id')?.name || '';
    }
  }

  /** A nyomtatási lap külön dokumentum: a relatív kép-címeket ott nem oldaná fel ugyanígy. */
  private abszolutCim(cim?: string): string | undefined {
    if (!cim) return undefined;
    try { return new URL(cim, document.baseURI).href; } catch (e) { return undefined; }
  }

  nyomtatasMegnyit() {
    if (!this.kivalasztottAzonosito()) {
      this.data.sendToast('Előbb válaszd ki, kinek vagy minek az órarendjét nyomtatod.', 'warning');
      return;
    }
    this.nyomtatas.cim = this.kivalasztottNev();
    this.nyomtatasmodal.present();
  }

  nyomtatasInditas() {
    if (!this.calapi) return;
    const html = orarendNyomtatasHtml({
      nezet: this.nyomtatasNezet(),
      kivalasztott: this.kivalasztottAzonosito(),
      cim: this.nyomtatas.cim || this.kivalasztottNev(),
      intezmeny: this.sajatIntezmeny?.intezmenyName || '',
      iskolaLogo: this.abszolutCim(this.sajatIntezmeny?.intezmenyKep),
      sulinformLogo: this.abszolutCim('assets/icon/sulinform-nyomtatas.png'),
      hetKezdete: this.calapi.view.currentStart,
      datumMutat: this.nyomtatas.datumMutat,
      helyettesitesekkel: this.nyomtatas.helyettesitesekkel,
      csengetes: this.csengetes || [],
      orak: this.hetOrak || [],
    });
    if (!(this.hetOrak || []).length) {
      this.data.sendToast('Ezen a héten nincs óra – üres lap készül. Lapozz arra a hétre, amelyiket nyomtatnád.', 'warning');
    }
    this.nyomtatasmodal.dismiss();
    nyomtatHtml(html);
  }
  async onCalendarReady() {
    //this.calapi = this.cal.getApi()
    // Guard against double init if the view is reattached
    if (!this.calapi) {
      this.calapi = await this.cal.getApi(); //return;
    }
    // First layout pass (important if the calendar was hidden in a tab/modal/*ngIf)
    setTimeout(async () => {

      this.sajatIntezmeny = await (this.data.getFromStorage("sajatIntezmeny"));
      this.csengetes = await this.data.getCsengetes(moment(this.tankezd).format("YYYY"), this.sajatIntezmeny.intezmenyId).toPromise();

      //this.calendarOptions.slotMaxTime = (this.csengetes.length + 1) + ':00:00'
      this.calapi!.setOption('slotMaxTime', `${this.csengetes.length + 1}:00:00`);
      //this.calapi.gotoDate('2024-09-01'); 



      if (moment(new Date()).isBetween(moment(new Date().getFullYear() + "-08-01"), moment(new Date().getFullYear() + "-08-31"), 'day', '[]')) {
        this.calapi.gotoDate(moment(this.tankezd).format("YYYY-MM-DD"))
        this.calapi.setOption("initialDate", moment(this.tankezd).format("YYYY-MM-DD"))
        this.calapi.gotoDate(this.tankezd)
      }
      this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
      //this.emptyHet(this.isoWeekNumber(this.calapi.getDate()))
      //this.latottHet.push(this.isoWeekNumber(this.calapi.getDate()));

      this.calapi!.render();
      //this.calapi.setOption('slotMaxTime', (this.csengetes.length + 1) + ':00:00');
      // Now it's safe to use it
      const current = this.calapi!.getDate();   // <-- should NOT be undefined now+

      // ... your addEvent/replace logic ...
    }, 0);

  }
  prev() { this.calapi.prev(); this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart); }
  next() { this.calapi.next(); this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart); }
  today() { this.calapi.today(); this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart); }
  changeView(v: string) {
    this.view = v;
    this.calapi.changeView(v);
  }

  private buildTitle(start: Date, end: Date) {
    const weekNum = this.isoWeekNumber(start);

    /*if (!this.latottHet.includes(weekNum)) {
      this.emptyHet(weekNum)
      this.latottHet.push(weekNum);
    } else {
      //this.getHetOrak(weekNum)
    }*/
    const endInc = new Date(end); endInc.setDate(endInc.getDate() - 1);
    //return `${weekNum}. hét (${this.huDate(start)} – ${this.huDate(endInc)})`;
    return `${this.huDate(start)} - ${this.huDate(endInc)}`;
    //if(this.huDate(start)=="1900. január 1.") return "A hét"
    //else if(this.huDate(start)=="1900. január 8.") return "B hét"
    //else if(this.huDate(start)=="1900. január 8.") return "B hét"
    //else if(this.huDate(start)=="1900. január 8.") return "B hét"
    //else return ""
  }
  private huDate(d: Date) {
    return `${d.getFullYear()}. ${d.toLocaleDateString('hu-HU', { month: 'long' })} ${d.getDate()}.`;
  }
  private isoWeekNumber(d: Date) {
    const tmp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const day = tmp.getUTCDay() || 7;
    tmp.setUTCDate(tmp.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
    return Math.ceil((((tmp as any) - (yearStart as any)) / 86400000 + 1) / 7);
  }
  changeMainNezet() {
    this.data.setStorage("orarendNezet", this.nezet)
    /*  Nézetváltáskor a korábbi kiválasztás (pl. egy osztály azonosítója) az új nézetben
     *  értelmetlen: töröljük, és kiürítjük a rácsot, amíg az új elemet ki nem választják. */
    this.kivosztaly = null
    this.kivtanar = null
    this.kivterem = null
    this.kivtantargy = null
    this.hetOrak = []
    if (this.calapi) this.onCalendarReady()
  }

  emptyHet(weekNum, start) {
    this.calapi.removeAllEvents()
    for (let i = 0; i < 7; i++) {
      for (let j = 0; j < this.csengetes.length + 1; j++) {
        const baseDate = moment(start).add(i, 'days').format('YYYY-MM-DD');
        const hh = String(j).padStart(2, '0');
        const key = `${baseDate}T${hh}:00`;         // stable slot key
        const id = `add-${key}`;
        if (moment(start).add(i, 'days').isBetween(moment(this.tankezd), moment(this.tanvege), 'day', '[]') && this.orarenduzemmod == "admin")
          this.calapi.addEvent({
            id: id,
            title: '<div style="text-align:center;line-height:115px;vertical-align:middle;cursor:pointer"><ion-icon name="add-circle-outline" size="large"></ion-icon></div>',
            start: moment(start).add(i, 'days').format("YYYY-MM-DD") + 'T' + String(j).padStart(2, '0') + ':00:00', end: moment(start).add(i, 'days').format("YYYY-MM-DD") + 'T' + String(j + 1).padStart(2, '0') + ':00:00',
            textColor: 'var(--ion-color-primary)', backgroundColor: 'transparent', borderColor: 'var(--ion-color-primary)',

          })
        if (i == 6 && j == this.csengetes.length) this.getHetOrak(weekNum)
        if (i == 6 && j == this.csengetes.length) this.getEsemenyek(weekNum)
      }
    }

  }

  async changeOrarendUzemmod(uzemmod) {
    let umd = await this.data.getFromStorage("userMetadata")
    if (uzemmod == this.orarenduzemmod) { this.orarenduzemmod = "orarend"; return }
    else
      if (umd.department == "admin" || umd.extra_jogok.indexOf(uzemmod) !== -1) {
        this.orarenduzemmod = uzemmod
      } else {
        this.data.sendToast("Nincs jogosultságod a funkcióhoz!", "error")
        return
      }

    if (this.orarenduzemmod == "admin") {
      //this.calapi.removeAllEvents()
    } else {
      this.calapi.getEvents()
        .filter(ev => String(ev.id).startsWith("add"))
        .forEach(ev => ev.remove());
    }

    this.onCalendarReady()

  }




  /**
   *  Az óra kártyacíme (a sortörések adják a kártya sorait).
   *
   *  A hiányzó mezőt KIHAGYJUK: a korábbi sorfűzés a `null`-t is beleírta, ezért annál
   *  a tanárnál, akinek nincs feladatellátás-kódja, „(null)" jelent meg a kártyán.
   *  Nincs kód → nincs zárójeles rész sem.
   */
  private oraCim(e: any): string {
    const szoveg = (v: any) => (v === null || v === undefined ? '' : String(v).trim());
    const zarojel = (v: any) => (szoveg(v) ? ` (${szoveg(v)})` : '');
    /*  Bontott órán nincs egyetlen osztály (a csoport többet fog össze), ezért ott a
     *  CSOPORT nevét írjuk ki – enélkül a kártyán csak a tantárgy állt, kötőjellel. */
    const cel = szoveg(e.osztaly) || szoveg(e.csoportnev);
    /*  Az elmaradt óra önálló állapot (2026-10-15), helyettesítő nélkül. A régi „E” módú óránál a
     *  helyettesítés-jelölés áthúzta a tartó tanárt – ez marad: az áthúzás nélkül a kártya
     *  rendes órának látszana, a felirat magában nem elég feltűnő. */
    const elmaradt = Number(e.elmaradt) === 1 && !e.helyettesito;
    const fejlec = `${szoveg(e.tantargy)} - ${cel}`
      + (e.helyettesito ? ` (${szoveg(e.helyettesites_tipus)}-${szoveg(e.helyettesites_mod)})<s>` : '')
      + (Number(e.elmaradt) === 1 ? ' – ELMARAD' : '')
      + (elmaradt ? '<s>' : '');
    const tarto = `${szoveg(e.tarto)}${zarojel(e.tartokod)}`;
    const helyettes = e.helyettesito
      ? `</s>${szoveg(e.helyettesito)}${zarojel(e.helyettesitokod)}\n` : (elmaradt ? '</s>' : '');
    //  A kötött túlóra a kártyán is látszik – különben csak az ablak megnyitásával derülne ki.
    const tulora = Number(e.tulora) === 1 ? '\nKötött túlóra' : '';
    return `${fejlec}\n${tarto}\n${helyettes}${szoveg(e.terem)}${tulora}`;
  }

  /**
   *  CSOPORTVÁLASZTÁS → TANTÁRGY.
   *
   *  Egy bontott csoporthoz jellemzően EGY tantárgy tartozik (nyelvi csoport,
   *  fakultáció), ezért felesleges újra kiválasztani – és hibázni is lehet vele. A
   *  kiszolgáló három forrásból adja a javaslatot (a csoport beállítása, a
   *  tantárgyfelosztás, a csoport eddigi órái), és CSAK EGYÉRTELMŰ esetben: ahol a
   *  csoportnak több tantárgya van, ott nem tippel, és itt sem írunk semmit.
   *
   *  A mező szerkeszthető marad: a kivétel is eset, csak nem az alapértelmezés.
   */
  csoportValt(ev: any) {
    const id = ev?.detail?.value;
    if (!id) return;                                   // „Teljes osztály" – nincs mit beégetni
    const cs: any = (this.csoportok || []).find((c: any) => String(c.id) === String(id));
    const javaslat = cs?.tantargy_javaslat;
    if (!javaslat) return;
    if (String(this.formo?.value?.tantargy || '') === String(javaslat)) return;
    this.formo.patchValue({ tantargy: javaslat });
    const nev = (this.tantargy || []).find((t: any) => String(t.id) === String(javaslat))?.name || '';
    this.data.sendToast(`Tantárgy beállítva: ${nev} (${cs.tantargy_forras} alapján).`, 'success');
  }

  getHetOrak(het) {

    this.http
      .get(
        '/api/orarend/f/' + moment(this.calapi.view.currentStart).format("YYYY") + '/' + het + '/' + this.nezet + '/' + (this.kivtanar ?? this.kivosztaly ?? this.kivterem ?? this.kivtantargy) + '/' + this.sajatIntezmeny.intezmenyId,
        {
        }
      ).subscribe({
        next: (response: any) => {
          this.hetOrak = Array.isArray(response) ? response : [];
          this.calapi.batchRendering(() => {
          response.forEach(e => {
            let i = e.nap;
            let j = e.ora
            //console.log(e)
            const baseDate = moment(e.datum).format('YYYY-MM-DD');

            //console.log(e)
            const hh = String(j).padStart(2, '0');
            const key = `${baseDate}T${hh}:00`;
            const id = `placeholder-${key}`;
            let h = this.calapi.getEventById(id);//this.cal.getApi().getEventById(moment(e.datum).format("YYYY-MM-DD")+"T"+String(i).padStart(2, '0')+String(j).padStart(2, '0'))
            //if (h) h.remove() NEM TÖRÖLJÜK A CSOPORTBONTÁS MIATT!
            let g = 1
            while (this.calapi.getEventById(id + g)) {
              g++
            }
            this.calapi.addEvent({
              id: id + g,
              title: this.oraCim(e),
              start: moment(e.datum).format("YYYY-MM-DD") + 'T' + String(j).padStart(2, '0') + ':00:00', end: moment(e.datum).format("YYYY-MM-DD") + 'T' + String(j + 1 * e.hossz).padStart(2, '0') + ':00:00',
              textColor: moment(e.datum).isBefore(moment()) ? 'var(--ion-color-primary-contrast)' : 'white', backgroundColor: moment(e.datum).isBefore(moment()) ? (!e.helyettesito ? e.tartoszin : "#ff0095ff") || 'var(--ion-color-primary)' : 'grey', borderColor: moment(e.datum).isBefore(moment()) ? e.helyettesito ? '#fccdfe' : 'var(--ion-color-primary-shade)' : 'grey',
              extendedProps: { ...e, originalBg: moment(e.datum).isBefore(moment()) ? (!e.helyettesito ? e.tartoszin : "#ff0095ff") || 'var(--ion-color-primary)' : 'grey', originalBorder: moment(e.datum).isBefore(moment()) ? e.helyettesito ? '#fccdfe' : 'var(--ion-color-primary-shade)' : 'grey', originalText: moment(e.datum).isBefore(moment()) ? 'var(--ion-color-primary-contrast)' : 'white', isSelected: false }
            })
            //this.calapi.today()
            /*if (h) {
              this.calapi.batchRendering(() => {
                h.setProp("title", e.tantargy + " - " + (e.osztaly || e.csoportnev || '') + "\n" + e.tarto + " (" + e.tartokod + ")\n(" + e.terem + ")")
                h.setProp("textColor", "var(--ion-color-primary-contrast)")
                h.setProp("backgroundColor", "var(--ion-color-primary)")
                h.setProp("borderColor", "var(--ion-color-primary-shade)")
              });
              this.calapi.render();
              //setTimeout(() => api.render(), 0);
              //this.cal.getApi().refetchEvents();
              //setTimeout(() => this.cal.getApi().render(), 0);
              //console.log(this.calapi.getEvents())
            }*/
            //if (h) h.remove()

            /*this.cal.getApi().addEvent({
              id: moment(this.cal.getApi().getDate()).add(i, 'days').format("YYYY-MM-DD") + 'T' + String(i).padStart(2, '0') + String(j).padStart(2, '0'),
              title: '<div style="text-align:center;line-height:115px;vertical-align:middle;cursor:pointer"><ion-icon name="add-circle" size="large"></ion-icon></div>',
              start: moment(this.cal.getApi().getDate()).add(i, 'days').format("YYYY-MM-DD") + 'T' + String(j).padStart(2, '0') + ':00:00', end: moment(this.cal.getApi().getDate()).add(i, 'days').format("YYYY-MM-DD") + 'T' + String(j + 1).padStart(2, '0') + ':00:00',
              textColor: 'var(--ion-color-primary)', backgroundColor: 'transparent', borderColor: 'var(--ion-color-primary)'
            })*/
          });
          });
          this.adjustFontSizeForCrowdedSlots();
          this.calapi.render();
          this.calendarready = true;

        }
      })
  }
  /**
   *  Az „Események" (egész napos) sor tartalma.
   *
   *  A tanév mérföldkövei a tanév-adatokból jönnek, a PROGRAMOK pedig a naptárból
   *  (tanév rendje) – korábban itt egyetlen bedrótozott „Kalandhét 2025" állt, ami a
   *  következő tanévben már félrevezetett. A szűrést a SZERVER végzi: a diák csak a
   *  publikált, rá vonatkozó eseményt kapja meg, a dolgozó mindent.
   */
  async getEsemenyek(weekNum) {
    this.calapi.addEvent({
      title: 'Első tanítási nap',
      start: this.tankezd, // YYYY-MM-DD is fine for all-day
      allDay: true
    });
    this.calapi.addEvent({
      title: 'Első félév utolsó napja',
      start: this.tanfelev, // YYYY-MM-DD is fine for all-day
      allDay: true
    });
    this.calapi.addEvent({
      title: 'Utolsó tanítási nap',
      start: this.tanvege, // YYYY-MM-DD is fine for all-day
      allDay: true
    });

    await this.naptariProgramok();
    this.calapi.render()
  }

  /** A megjelenített hétre eső naptári programok betöltése az eseménysávba. */
  private async naptariProgramok() {
    if (!this.calapi || !this.sajatIntezmeny?.intezmenyId) return;
    const tol = moment(this.calapi.view.currentStart).format('YYYY-MM-DD');
    const ig = moment(this.calapi.view.currentEnd).subtract(1, 'day').format('YYYY-MM-DD');

    // A belépési mód dönti el, kell-e szűrni: dolgozónál nem, diáknál igen.
    const mod = await this.data.getFromStorage('loginmode');
    const umd: any = await this.data.getFromStorage('userMetadata');
    const tanulo = mod === 'tanulo' ? (umd?.oktazon || umd?.username || '') : '';

    try {
      const p = new URLSearchParams({ tol, ig, mod: mod || 'dolgozo' });
      if (tanulo) p.set('tanulo', String(tanulo));
      const r: any = await this.http
        .get(`/api/tanevrendje/orarend/${this.sajatIntezmeny.intezmenyId}?${p.toString()}`).toPromise();
      for (const e of (r?.esemenyek || [])) this.calapi.addEvent(this.naptarEsemeny(e));
    } catch (err) {
      // Az eseménysáv nem viheti magával az órarendet: ha nem jön, csak kimarad.
      console.warn('Naptári programok betöltése sikertelen:', err);
    }
  }

  /**
   *  Naptári bejegyzés → egész napos esemény. A vége FullCalendarban kizárólagos,
   *  ezért a több napos program utolsó napjához +1 nap kell, különben lemarad.
   */
  private naptarEsemeny(e: any) {
    const kezd = moment(e.kezdes);
    const veg = e.vege ? moment(e.vege) : kezd.clone();
    return {
      id: 'tkt-' + e.id,
      title: esemenyCimHtml(e.ikon, e.nev),
      start: kezd.format('YYYY-MM-DD'),
      end: veg.clone().add(1, 'day').format('YYYY-MM-DD'),
      allDay: true,
      backgroundColor: '#6b7fd7',
      borderColor: '#5468b8',
      textColor: '#fff',
      extendedProps: { naptar: e },
    };
  }
  private async onEventClick(arg: EventClickArg) {
    let insertorupdate = "insert"
    this.ujOra = true
    const event = arg.event;
    const meta = (event.extendedProps || {});
    this.oraevent = event
    this.orameta = meta
    this.blokk = await this.data.getBlokk(moment(event.start).format("YYYY-MM-DD"), moment(event.start).format("H"), this.sajatIntezmeny.intezmenyId).toPromise();
    this.allomanyKi = this.allomany.map(t => ({
      ...t,
      disabled: (this.blokk["helyettesitoid"]?.includes(t.adid) || this.blokk["tanarid"]?.includes(t.adid)) && t.adid != meta.tanar && t.adid != meta.helyettesito_tanar ? true : false
    }));
    this.allomanyBe = this.allomany.map(t => ({
      ...t,
      disabled: !(this.blokk["helyettesitoid"]?.includes(t.adid) || this.blokk["tanarid"]?.includes(t.adid)) && t.adid != meta.tanar && t.adid != meta.helyettesito_tanar ? true : false
    }));
    //console.log(event)
    moment.locale('hu')
    this.formo.patchValue({
      erv_kezd: moment(event.start).format("YYYY-MM-DD"),
      nap: moment(event.start).format("dddd"),
      napszam: moment(event.start).day(),
      ora: moment(event.start).format("H")
    })

    if (meta.tanar) {
      insertorupdate = "update"
      this.ujOra = false
      this.formo.patchValue({
        osztaly: meta.osztalyid,
        tanterem: meta.helyiseg,
        tantargy: meta.tantargyid,
        selectedUser: [meta.tanar],
        hossz: meta.hossz || 1,
        csoport: meta.csoport ?? null,
        tulora: Number(meta.tulora) === 1
      })
    } else {
      this.formo.patchValue({
        osztaly: this.kivosztaly,
        tanterem: this.kivterem,
        tantargy: this.kivtantargy,
        selectedUser: this.kivtanar ? [this.kivtanar] : [],
        csoport: null,
        tulora: false
      })
    }

    // Example: “create something” — open a quick prompt to add/edit a note
    // Replace with a real Dialog/Drawer in your app
    /*const newNote = prompt(
      `Create/update note for "${event.title}"\nExisting: ${meta ?? '(none)'}\n\nEnter note:`,
      meta.notes ?? ''
    );*/
    if (this.orarenduzemmod == "admin") {
      const modal = this.orarendmodal
      await modal.present(); // important: present before awaiting dismiss

      const { data, role } = await modal.onDidDismiss<{}>();

      //    console.log(data)
      if (data == 1) {
        await this.data.showLoading("Adatok feltöltése...")
        let fridays
        if (this.formo.value.ido == "O") fridays = this.getWeekdaysBetween(this.tankezd, this.tanvege, this.formo.value.napszam);
        /*  „I. Félév” = a tanév ELEJÉTŐL a félév végéig, ahogy a „II. Félév” is a félév végétől
         *  a tanév végéig tart. Eddig a kiválasztott órától számolt: egy szeptember végi órán
         *  beállított kötött túlóra a hónap elejének óráira nem került rá (Zenit, 2026-10-01).
         *  Ha csak innentől kell, arra az „Ettől a héttől” való. */
        else if (this.formo.value.ido == "I") fridays = this.getWeekdaysBetween(this.tankezd, this.tanfelev, this.formo.value.napszam);
        else if (this.formo.value.ido == "II") fridays = this.getWeekdaysBetween(this.tanfelev, this.tanvege, this.formo.value.napszam);
        else if (this.formo.value.ido == "A") fridays = this.getWeekdaysBetween(event.start, this.tanvege, this.formo.value.napszam);
        else if (this.formo.value.ido == "B") fridays = this.getWeekdaysBetween(this.tankezd, event.start, this.formo.value.napszam);
        else if (this.formo.value.ido == "C") fridays = [moment(event.start).format("YYYY-MM-DD")];
        else { this.data.hideLoading(); return }
        //console.log(fridays.map(d => d.format("YYYY-MM-DD")));
        if (insertorupdate == "insert") {
          this.http
            .post(
              '/api/orarend/bulkinsert/' + this.sajatIntezmeny.intezmenyId,
              {
                days: fridays,
                data: { ...this.formo.value, tanev: moment(this.tankezd).format("YYYY") }
              }
            ).subscribe({
              next: (response: any) => {
                this.data.hideLoading()
                this.formo.reset()
                this.formo.patchValue({ hetirend: "O", ido: "C", hossz: 1, darab: 1 })
                /*  A darabszámot KIÍRJUK. Egy néma „Sikeres mentés" itt félrevezetne:
                 *  a felhasználó ötöt kért, és nem látná, hogy hármat kapott, mert
                 *  kettőn már volt óra. */
                const db = Number(response?.letrehozott ?? 0)
                const kihagy = Array.isArray(response?.kihagyott) ? response.kihagyott.length : 0
                let uzenet = db > 1 ? `${db} óra létrehozva.` : "Sikeres mentés!"
                if (!db) uzenet = response?.uzenet || "Nem jött létre új óra."
                if (kihagy) uzenet += ` ${kihagy} órahelyet kihagytunk, mert már volt rajta óra.`
                this.data.sendToast(uzenet, kihagy ? "warning" : (db ? "success" : "warning"))
                this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
              },
              error: (error) => {
                this.data.hideLoading()
              }
            })
        } else if (insertorupdate == "update") {
          this.http
            .post(
              '/api/orarend/bulkupdate/' + this.sajatIntezmeny.intezmenyId,
              {
                days: fridays,
                original: {
                  osztaly: meta.osztalyid,
                  ora: meta.ora,
                  csoport: meta.csoport ?? null
                },
                data: { ...this.formo.value, tanev: moment(this.tankezd).format("YYYY") }
              }
            ).subscribe({
              next: (response: any) => {
                this.data.hideLoading()
                this.formo.reset()
                this.formo.patchValue({ hetirend: "O", ido: "C", hossz: 1, darab: 1, csoport: null })
                this.data.sendToast("Óra módosítva!", "success")
                this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
              },
              error: (error) => {
                this.data.hideLoading()
                {
                  //  A kiszolgáló hibája lehet objektum is (régi válaszok) – soha ne „[object Object]” legyen kiírva.
                  const h = error?.error?.error
                  const szoveg = typeof h === 'string' ? h : (h?.sqlMessage || h?.message || '')
                  this.data.sendToast(szoveg ? `Nem sikerült módosítani az órát: ${szoveg}` : "Nem sikerült módosítani az órát.", "error")
                }
              }
            })
        }
      } else if (data == 2) {

      } else {
        this.formo.reset()
        this.formo.patchValue({ hetirend: "O", ido: "C", hossz: 1, darab: 1 })
        this.data.sendToast("Megszakítva!", "info")
        try { await this.data.hideLoading() } catch (error) { }

      }
    } else if (this.orarenduzemmod == "helyettesites") {
      const modal = this.helyettesitesmodal
      this.helyettesitettOraElmaradt = Number(meta.elmaradt) === 1
      this.helyettesitettOraElmaradtOk = meta.elmaradt_ok || null
      this.formh.patchValue({
        tipus: meta.helyettesites_tipus || "E",
        //  A régi „E” (elmaradt) mód már nem választható: önálló állapot, külön gombbal.
        mod: (meta.helyettesites_mod && meta.helyettesites_mod !== 'E') ? meta.helyettesites_mod : "H",
        ido: "C",
        selectedUser: meta.helyettesito_tanar || null
      })
      await this.helyettesitoJeloltekBetolt(meta, event.start)
      this.helyettesitesModValt()
      await modal.present();
      const { data, role } = await modal.onDidDismiss<{}>();
      await this.data.showLoading("Mentés...")
      if (data == 1) {

        this.http
          .post(
            '/api/orarend/bulkkonyvel/' + this.sajatIntezmeny.intezmenyId,
            {
                data: [{ id: meta.id, helyettesites: 1,
                  helyettesito: this.formh.getRawValue().mod === 'E' ? (this.elmaradtTanar() || this.formh.getRawValue().selectedUser) : this.formh.getRawValue().selectedUser,
                  helyettesites_tipus: this.formh.getRawValue().tipus, helyettesites_mod: this.formh.getRawValue().mod }]
            }
          ).subscribe({
            next: (response: any) => {
              console.log(response)
              this.data.hideLoading()
              this.formh.get('selectedUser')?.enable({ emitEvent: false }); this.formh.reset()
                this.formh.patchValue({ mod: "H", tipus: "E", ido: "C", selectedUser: null })
              this.data.sendToast("Sikeres kiírás!", "success")
              this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
            },
            error: (error) => {
              this.data.hideLoading()
            }
          })
      } else if (data == 2) {
        this.http
          .post(
            '/api/orarend/bulkkonyvel/' + this.sajatIntezmeny.intezmenyId,
            {
              data: [{ id: meta.id, helyettesites: 0, helyettesito: 'null', helyettesites_tipus: 'null', helyettesites_mod: 'null' }]
            }
          ).subscribe({
            next: (response: any) => {

              this.data.hideLoading()
              this.formh.get('selectedUser')?.enable({ emitEvent: false }); this.formh.reset()
              this.formh.patchValue({ mod: "H", tipus: "E", ido: "C", selectedUser: null })
              this.data.sendToast("Sikeres törlés!", "success")
              this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
            },
            error: (error) => {
              this.data.hideLoading()
            }
          })
      } else if (data == 3 || data == 4) {
        //  ELMARADT jelölése / visszavonása – naplózva, a lezárt naplóidőszakot a kiszolgáló tiltja.
        const jelol = data == 3
        const ok = jelol ? prompt('Az elmaradás oka (pl. táppénz, kirándulás):', '') : ''
        if (jelol && ok === null) {
          try { await this.data.hideLoading() } catch (error) { }
        } else {
          this.http
            .post('/api/ora-naplo/elmaradt/' + this.sajatIntezmeny.intezmenyId,
              { ora_id: meta.id, elmaradt: jelol, ok: (ok || '').trim() || null })
            .subscribe({
              next: () => {
                this.data.hideLoading()
                this.formh.get('selectedUser')?.enable({ emitEvent: false }); this.formh.reset()
                this.formh.patchValue({ mod: "H", tipus: "E", ido: "C", selectedUser: null })
                this.data.sendToast(jelol ? "Az óra elmaradtként jelölve." : "Az elmaradt jelölés visszavonva.", "success")
                this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
              },
              error: (e: any) => {
                this.data.hideLoading()
                this.data.sendToast(e?.error?.error || "Nem sikerült a jelölés.", "error")
              }
            })
        }
      } else {
        this.formh.get('selectedUser')?.enable({ emitEvent: false }); this.formh.reset()
        this.formh.patchValue({ mod: "H", tipus: "E", ido: "C", selectedUser: null })
        this.data.sendToast("Megszakítva!", "info")
        try { await this.data.hideLoading() } catch (error) { }
      }
    } else if (this.orarenduzemmod == "torles") {
      const isSelected = !!event.extendedProps['isSelected'];

      if (isSelected) {
        // restore original colors
        event.setProp('backgroundColor', event.extendedProps['originalBg']);
        event.setProp('borderColor', event.extendedProps['originalBorder']);
        event.setProp('textColor', event.extendedProps['originalText']);
        event.setExtendedProp('isSelected', false);
      } else {
        // selected state color
        event.setProp('backgroundColor', '#4c1d95');
        event.setProp('borderColor', '#4c1d95');
        event.setProp('textColor', '#ffffff');
        event.setExtendedProp('isSelected', true);
      }

    }
  }



  getWeekdaysBetween(startDate, endDate, weekday) {
    const dates = [];
    let current = moment(startDate).startOf("day");
    const end = moment(endDate).startOf("day");

    // move to first desired weekday on/after startDate
    if (current.day() !== weekday) {
      current.add((weekday - current.day() + 7) % 7, "days");
    }

    while (current.isSameOrBefore(end)) {
      dates.push(current.clone().format("YYYY-MM-DD"));
      current.add(7, "days");
    }

    return dates;
  }
  adjustFontSizeForCrowdedSlots() {
    if (!this.calapi) return;

    // Get all events currently in the calendar
    const events = this.calapi.getEvents();

    // Group events by their start date/time string
    const grouped: Record<string, any[]> = {};
    events.forEach(event => {
      const key = event.start?.toISOString(); // grouping by exact start time
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(event);
    });

    // Loop over each time group
    for (const key in grouped) {
      if (grouped[key].length > 2) {
        // More than 2 events in this slot → reduce font size
        grouped[key].forEach(ev => {
          ev.setProp('title', `<div style="font-size:10px;">${ev.title}</div>`);
        });
      }
    }
  }

  async init() {
    this.isSlotFilled = [];
    this.cardInSlot = [];
    this.ttf = [];
    this.slots = [];
    this.cards = [];
    this.filled = [];
    this.elhasznalt = [];
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"));
    this.allomany = await this.data.getAllomany(this.sajatIntezmeny.intezmenyId).toPromise();
    /*this.allomany.forEach(a => {
      this.allomany[a.adid] = a
      this.allomany[a.adid].intezmenyadatok = JSON.parse(this.allomany[a.adid].intezmenyadatok)[0]
    })*/
    console.log(this.allomany)



    /*this.osztaly.forEach(o => {
      this.isSlotFilled[o.id] = new Array(this.slots.length).fill(false);
      this.cardInSlot[o.id] = new Array(this.slots.length).fill('');
    })*/
    //this.csengetes = await this.data.getCsengetes("2024", this.sajatIntezmeny.intezmenyId).toPromise();
    //this.calendarOptions.slotMaxTime = (this.csengetes.length + 1) + ':00:00'
    //this.calapi.setOption('slotMaxTime', (this.csengetes.length + 1) + ':00:00');




    /*
        let ttf = await this.data.getTtf("2024", this.sajatIntezmeny.intezmenyId).toPromise();
        ttf.forEach(t => {
          if (t.ttfel == "[null]") {
          } else if (t.ttfel != "[null]") {
            t.ttfel = JSON.parse(t.ttfel);
            for (let i = 0; i < t.ttfel.length; i++) {
              //for(let j = 0; j<t.db; j++){
              this.ttf.push(
                {
                  id: t.id,
                  ttfelid: t.ttfel[i].id,
                  tantargy: t.tantargy,
                  db: t.ttfel[i].db,
                  //hanyadik:j+1,
                  evfolyam: JSON.parse(t.evfolyam),
                  nev: t.nev,
                  rovid: t.rovid,
                  szin: t.szin,
                  ttfel: t.ttfel[i],
                  csoport: i,
                  bontas: t.ttfel.length > 1 ? 1 : 0,
                  orarend: t.orarend,
                  munkatars: t.munkatars
                }
              )
              //}
            }
          }
        })*/

  }

  shuffle(array: string[]) {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  onDragStart(event: DragEvent, card: string) {
    this.mostdrag = card
    event.dataTransfer?.setData('json', JSON.stringify(card));
  }

  allowDrop(event: DragEvent, filled, iod, j, i) {
    for (let k = 0; k < this.osztaly.length; k++) this.mouseLeave(k, i)
    this.mouseEnter(j, i)
    if (!filled && iod == this.mostdrag.evfolyam.id)
      event.preventDefault();
  }

  onDrop(event: DragEvent, ora: string, index: number, oid) {

    event.preventDefault();
    const card = JSON.parse(event.dataTransfer?.getData('json'));
    console.log(card)
    //console.log(Math.floor(index/this.csengetes.length*10).toString()[0])
    if (card && !this.isSlotFilled[oid][index]) {

      /*this.cards.forEach(c=>{
        if(card.id == c.id && card.munkatars == c.munkatars && c.db>0) c.db--;
        else if(card.id == c.id && card.munkatars == c.munkatars && c.db==0) this.cards = this.cards.filter(cd => cd.id !== card.id && cd.munkatars !== card.munkatars);
      })*/

      if (card.orarend?.hossz) card.orarend.hossz = 1

      this.isSlotFilled[oid][index] = true; // Mark slot as filled
      this.cardInSlot[oid][index] = card; // Store card in slot
      let nap, ora, hossz: number
      let id
      if (Math.floor(index / this.csengetes.length * 10).toString().length == 1) {
        nap = 0
        ora = Math.floor(index / this.csengetes.length * 10).toString()
      } else {
        nap = Math.floor(index / this.csengetes.length * 10).toString()[0];
        ora = Math.floor(index / this.csengetes.length * 10).toString()[1];
      }
      hossz = 1;

      let rh = 1 //(<HTMLTableCellElement>document.getElementById(oid+(index-1))).colSpan ?? 1;//this.cardInSlot[oid][index]?.ohossz ?? card.orarend?.hossz ?? 1
      for (let k = 1; k < parseInt(ora); k++) {
        if ((<HTMLTableCellElement>document.getElementById(oid + (index - k)))?.colSpan == null) {
          //console.log("nincs")
          rh++;
        }
      }
      // Remove the card from the pile to indicate it's been placed
      //this.cards = this.cards.filter(c => c.ttfelid !== card.ttfelid);
      console.log(this.cardInSlot[oid][index - rh]?.orarend?.ora)
      console.log(rh)
      console.log(ora)

      if (parseInt(ora) - parseInt(this.cardInSlot[oid][index - rh]?.orarend?.ora) > 0 && this.isSlotFilled[oid][index - rh] && this.cardInSlot[oid][index - rh].tantargy == card.tantargy && card.ttfel.munkatars == this.cardInSlot[oid][index - rh].ttfel.munkatars) {
        ora = ora - rh;
        hossz = rh + 1;
        id = "'" + this.cardInSlot[oid][index - rh].orarend.id + "'"
      } else if (parseInt(this.cardInSlot[oid][index + 1]?.orarend?.ora) - parseInt(ora) > 0 && this.isSlotFilled[oid][index + 1] && this.cardInSlot[oid][index + 1].tantargy == card.tantargy && card.ttfel.munkatars == this.cardInSlot[oid][index + 1].ttfel.munkatars) {
        ora = parseInt(ora);
        hossz = this.cardInSlot[oid][index + 1]?.orarend?.hossz + 1;
        id = "'" + this.cardInSlot[oid][index + 1].orarend.id + "'"
      } else {
        id = 'uuid()';
      }
      const body = {
        id: id,
        intezmeny: this.sajatIntezmeny.intezmenyId,
        ev: 2024,
        het: 'A',
        ttf: card.ttfelid,
        nap: nap,
        ora: ora,
        hossz: hossz,
        munkatars: card.munkatars
      };
      this.http
        .post(
          '/api/orarend', body,
          /*{
            //headers: headers,
          }*/
        )
        .subscribe({
          next: (response: any) => {
            if (this.cardInSlot[oid][index - rh]?.orarend) {
              //this.cardInSlot[oid][index-rh].orarend.hossz = hossz;
              //this.cardInSlot[oid][index-rh].orarend.ora = ora;
            }
            this.init();
            //console.log(response)
          }
        })


    } else console.log("boo")
  }

  mouseEnter(j, i) {
    document.getElementById("j" + j).style.background = "yellow"
    document.getElementById("i" + i).style.background = "yellow"
  }
  mouseLeave(j, i) {
    document.getElementById("j" + j).style.background = "unset"
    document.getElementById("i" + i).style.background = "unset"
  }

  cardClass(i) {
    if (i > 1) return " tobb"
    return ""
  }

  utolsoOra(m, i) {
    if (Number.isInteger(i / m)) return "utolso"
    return ""
  }

  // TypeScript Component Logic
  shouldRenderCell(osztalyId: number, slotIndex: number): boolean {
    /*if (!this.isSlotFilled[osztalyId][slotIndex]) {
      return true; // Render empty slot
    }*/

    // Check if the cell at the current index is already covered by a previous cell's colspan
    for (let i = 0; i < slotIndex; i++) {
      if (this.cardInSlot[osztalyId][i]?.orarend) {
        const colspan = this.cardInSlot[osztalyId][i]['orarend'].hossz;
        if (i + colspan > slotIndex) {
          return false; // Current index is covered by a previous colspan
        }
      }
    }
    return true; // Render normally if not covered
  }


  ttModal(ok, id, i) {
    if (!ok) return
    this.kivalasztottora = this.cardInSlot[id][i]
    this.modal.present();
  }
  onWillDismiss(e) {

  }
  confirm() {
    //this.loader.present();
    //this.showLoading('Mentés...');
    this.modal.dismiss(null, 'confirm');
  }
  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  validateForm() {
    return false;
  }
  delOrarend() {

  }


  whatIsMyBg(id, i) {
    if (this.isSlotFilled[id][i] && this.cardInSlot[id][i]?.szin) {
      if (this.cardInSlot[id][i]?.orarend?.locked == 1) {
        return `repeating-linear-gradient(-55deg, ${this.cardInSlot[id][i]?.szin}, ${this.cardInSlot[id][i]?.szin} 10px, var(--ion-color-medium-shade) 10px, var(--ion-color-medium-shade) 20px) !important`
      } else {
        return this.cardInSlot[id][i]?.szin;
      }
    } else if (this.isSlotFilled[id][i] && !this.cardInSlot[id][i]?.szin) {
      if (this.cardInSlot[id][i]?.orarend?.locked == 1)
        return 'repeating-linear-gradient(-55deg, #666, #666 10px, var(--ion-color-medium-shade) 10px, var(--ion-color-medium-shade) 20px) !important'
      else
        return '#666'
    } else {
      return '#fff'
    }
    //return this.isSlotFilled[id][i] ? this.cardInSlot[id][i]?.szin ? this.cardInSlot[id][i]?.szin : '#666' : '#fff'
  }

  async openComponent(comp) {
    /*if(comp == "tanar") comp = TanarComponent
    if(comp == "tanterem") comp = TanteremComponent
    if(comp == "tantargy") comp = TantargyComponent
    if(comp == "osztaly") comp = OsztalyComponent*/

    const modal = await this.modalCtrl.create({
      component: OsztalyComponent,
      cssClass: 'modalom',
      componentProps: {
        compMod: comp
      }
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //this.name = data;
    }
  }


  open({ x, y }: MouseEvent, user) {
    this.close();
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(this.userMenu, this.viewContainerRef, {
      $implicit: user
    }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
        }),
        take(1)
      ).subscribe(() => this.close())

  }

  delete(user) {
    // delete user
    this.close();
  }

  addRecord(user) {
    alert("Add Record Test");
    this.close();

  }

  editRecord(user) {
    let data = JSON.stringify(user);
    alert("Edit Record Test" + data);
    this.close();
  }

  variableInfo(user) {
    alert("Variable Info Record Test");
    this.close();

  }



  close() {
    this.sub && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }




  async torlesOrarend() {
    await this.data.showLoading("Kijelölt tanórák törlése...")
    const events = this.calapi.getEvents();

    let kuld = events.filter(event => event.extendedProps.isSelected);
    //console.log(kuld)
    this.http
      .post(
        '/api/orarend/torolora',
        {
          data: kuld, method: this.torlesmod
        }
      ).subscribe({
        next: (response: any) => {
          this.data.hideLoading()
          this.formh.get('selectedUser')?.enable({ emitEvent: false }); this.formh.reset()
          /*  A beírt (naplózott) óra nem vész el: archívumba kerül, az admin visszaállíthatja; a
           *  lezárt naplóidőszak órái kimaradnak (backend/orarend.js › torolora). */
          const reszek = [`${response?.torolve ?? 0} óra törölve`]
          if (response?.archivalva) reszek.push(`ebből ${response.archivalva} beírt óra archiválva (visszaállítható)`)
          if (response?.kihagyva_lezart) reszek.push(`${response.kihagyva_lezart} óra lezárt naplóidőszakban – kimaradt`)
          this.data.sendToast(reszek.join(', ') + '.', response?.kihagyva_lezart ? "warning" : "success")
          this.emptyHet(this.isoWeekNumber(this.calapi.view.currentStart), this.calapi.view.currentStart);
        },
        error: (e: any) => {
          this.data.hideLoading()
          this.data.sendToast(e?.error?.error || "A törlés nem sikerült.", "error")
        }
      })
  }




}
